/**
 * Tab Component
 *
 * @file tab.js
 */

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };
  
  const multipleTab = () => {
    const tabsBtns = document.querySelectorAll(".b-tab-item");
    const tabsContents = document.querySelectorAll(".b-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };
  
  const multipleTab2 = () => {
    const tabsBtns = document.querySelectorAll(".c-tab-item");
    const tabsContents = document.querySelectorAll(".c-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };
  
  const hoverChangeDataImg = () => {
    document.querySelectorAll('.hover-change-img').forEach(btn => {
      btn.addEventListener('mouseenter', function () {
          const newImage = this.getAttribute('data-image');
          const targetImg = document.querySelector('.hover-changed-img img');
          if (targetImg) {
              targetImg.setAttribute('src', newImage);
          }
      });
  
      btn.addEventListener('mouseleave', function () {
          const targetImg = document.querySelector('.hover-changed-img img');
          if (targetImg) {
              const firstImage = targetImg.getAttribute('data-first-img');
              targetImg.setAttribute('src', firstImage);
          }
      });
    });
  };
  const userRequestTab = () => {
    const tabsBtns = document.querySelectorAll(".user-request-tab a");
    const requestItems = document.querySelectorAll(".user-request-tab-list-content a");

    tabsBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        
        // Tüm tab butonlarından active class'ını kaldır
        tabsBtns.forEach((el) => {
          el.classList.remove('active');
        });
        
        // Tıklanan butona active class'ını ekle
        this.classList.add('active');
        
        // href değerini al (# işaretini kaldır)
        const filterValue = this.getAttribute('href').substring(1);
        
        // Tüm talepleri göster/gizle
        requestItems.forEach((item) => {
          if (filterValue === 'tumu') {
            // Tümü seçildiğinde hepsini göster
            item.style.display = '';
          } else {
            // Diğer seçeneklerde sadece ilgili class'a sahip olanları göster
            if (item.classList.contains(`filter-${filterValue}`)) {
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          }
        });
      });
    });
  };

  const init = () => {
    defaultTab();
    multipleTab();
    multipleTab2();
    hoverChangeDataImg();
    userRequestTab();
  };

  return {
    init,
  };
})();

export default tabs;
